// Game configuration settings for Football Memory Game

const GameConfig = {
  // Memory Game Settings
  memoryGame: {
    // Timer settings
    timeLimit: 18, // seconds to complete the game
    
    // Game mechanics
    pairsNeeded: 3, // number of pairs needed to win
    maxCards: 16, // total cards in the grid (8 pairs)
    flipAnimationDuration: 700, // ms for card flip reveal/hide
    matchDisplayDuration: 1000, // ms to show matched cards before continuing
    
    // Grid layout
    gridColumns: 4, // 4x4 grid
    cardGap: 12, // gap between cards in pixels (mobile)
    cardGapDesktop: 16, // gap between cards in pixels (desktop)
    
    // Visual feedback
    highlightMatchedCards: true,
    showSuccessAnimation: true,
    confettiDuration: 5000, // ms for confetti animation
    
    // Prize configuration
    prizeName: "Ousmane Dembélé jersey",
    prizeImage: "/CardGame/Gift/gift-jersey.png",
    
    // Card assets
    cardIcons: [
      '/CardGame/footbal_icon.svg',
      '/CardGame/flag.svg',
      '/CardGame/jersey.svg',
      '/CardGame/whistle.svg',
      '/CardGame/boots.svg',
      '/CardGame/staduim.svg',
      '/CardGame/golden_ballsvg.svg',
      '/CardGame/ticket-479.svg',
    ],
    
    // Game flow
    startTimerOnFirstFlip: true, // timer starts when first card is flipped
    allowRestartDuringGame: true,
    showPreviewOnStart: false, // show all cards briefly at game start
  }
};

export default GameConfig;